import { Instance } from 'mobx-state-tree';
import { RouteLastLocationDtoModelBase } from './RouteLastLocationDtoModel.base';

/* The TypeScript type of an instance of RouteLastLocationDtoModel */
export interface RouteLastLocationDtoModelType extends Instance<typeof RouteLastLocationDtoModel.Type> {}

/* A graphql query fragment builders for RouteLastLocationDtoModel */
export { selectFromRouteLastLocationDto, routeLastLocationDtoModelPrimitives, RouteLastLocationDtoModelSelector } from './RouteLastLocationDtoModel.base';

/**
 * RouteLastLocationDtoModel
 */
export const RouteLastLocationDtoModel = RouteLastLocationDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
